export default __webpack_public_path__ + "static/media/77fb0d2f-076f-4a7b-8eef-7f914fdae155.3d9e6c0d.JPG";